module.exports = __webpack_public_path__ + "img/search-dollar-solid.ec937b18.svg";